<template>
  <div class="footer">
    <div class="footer__copy">
    Read the privacy policy <a href="https://www.channelsight.com/privacy-policy-diageo" target="_blank">here</a><br><br><br>
    Please do not share with anyone under the legal purchase age for alcohol. Drink Responsibly.
    </div>
  </div>
</template>
<script setup>
import dataModel from "../js/model.js";
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1",
  },
});
$(document).ready(function() {
  if(window.innerWidth < 600) {
    $('.footer').css({
      paddingBottom: '200px'
    })
  }
});
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.footer {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  background: #000000;
  padding: 30px 30px;
  width: 100%;
  @media screen and (max-width: $width--xs) {
      padding-bottom: 140px;
    }
}
.footer__copy {
  color: #f0f0f0;
  font-size: 12px;
  font-family: 'Mark Pro', sans-serif;
  line-height: 14px;
}
span {
  font-weight: 700;
}
a {
  color: #f0f0f0;
  text-decoration: underline;
}
</style>